import { format, startOfMonth, endOfMonth, differenceInDays } from 'date-fns'

//Retorna em que semana se encontra a dia informado dentro do mês informado
const getWeek = (date) => {
    //Para considerar que a semana começa no domingo deve ser considerado -1 (ao inves de -2)
    const dayWeekFirstDay = startOfMonth(date).getDay() - 2;

    return Math.floor((date.getDate() + dayWeekFirstDay) / 7);
}

const generateArrayWeeks = (monthsData, startDate, endDate) => {
    let weeksData = [];
    let weeksLabel = [];

    const weekStartDate = getWeek(startDate);
    const weekEndDate = getWeek(endDate);

    monthsData.forEach((month, index) => {
        //Obtem o mês e ano da variavel month
        let date = new Date(
            2000 + Number.parseInt(String(index).substring(0, 2)),//Obtém os dois primeiros numeros do index que representam o ano
            Number.parseInt(String(index).substring(2, 4)),//Obtém os dois ultimos numeros do index que representam o mês
            1 //O dia primeiro é usado por padrão
        );

        //Verifica quantas semanas o mês x possui
        const quantWeeksByMonth = getIndexMonth(endDate) === index ?
            weekEndDate :
            getWeek(endOfMonth(date));

        let startOn = 0;
        //Se for estiver no mesmo mes de startDate
        if (getIndexMonth(startDate) === index) {
            //tem que começar na semana que começa o startDate
            startOn = weekStartDate;
        }

        //Adiciona quantWeeksByMonth elementos nos arrays
        for (let i = startOn; i <= quantWeeksByMonth; i++) {
            weeksData[getIndexWeek(i, date)] = 0;
            //O formato será "W - Jan - YY" (W --> semana do mes onde se encontra a ocorrência)
            weeksLabel[getIndexWeek(i, date)] = (i + 1) + " - " + monthToString(date.getMonth()) + " - " + (date.getFullYear() - 2000);
        }
    });

    return {
        weeksData,
        weeksLabel
    };
}

const getIndexMonth = (date) => {
    //Os index do month devem seguir padrões para que se possa extrair informações
    //desses index, então um index de um mês é composto por YYMM

    return Number.parseInt(
        (date.getFullYear() - 2000) + //Subtrai 2000 para impedir que o index fique muito grande
        String(date.getMonth()).padStart(2, "0") //Sempre vai haver dois numeros representando o mês
    );
}

const getIndexWeek = (week, date) => {

    //Os index do month devem seguir padrões para que se possa extrair informações
    //desses index, então um index de um mês é composto por YYMMW (W é o getWeek)

    return Number.parseInt(
        (date.getFullYear() - 2000) + //Subtrai 2000 para impedir que o index fique muito grande
        String(date.getMonth()).padStart(2, "0") + //Sempre vai haver dois numeros representando o mês
        String(week)
    );
}

const monthToString = (month) => {
    const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
        "Jul", "Ago", "Set", "Out", "Nov", "Dez"]

    return months[month];
}

const generateArrayMonths = (startDate, endDate) => {
    let monthsLabel = [];
    let monthsData = [];

    let date = new Date(startDate.getTime());

    //Verificar o formatDistance do date-fns
    while (date <= endDate) {
        monthsLabel[getIndexMonth(date)] = monthToString(date.getMonth()) + " - " + (date.getFullYear() - 2000);
        monthsData[getIndexMonth(date)] = 0;
        date.setMonth(date.getMonth() + 1);
    }

    return {
        monthsData,
        monthsLabel
    };
}

const getIndexDay = (date) => {
    //O index deve ser unico para cada data
    //O formato do index será YYMMDD

    return Number.parseInt(
        String(date.getFullYear() - 2000) + //Formata o ano para mostrar somente os dois ultimos digitos
        String(date.getMonth()).padStart(2, "0") + //Força que o mês tenha dois digitos
        String(date.getDate()).padStart(2, "0")
    );
}

const generateArrayDays = (startDate, endDate) => {
    let daysData = [];
    let daysLabel = [];

    let date = new Date(startDate.getTime());

    while (date <= endDate) {
        daysData[getIndexDay(date)] = 0;
        daysLabel[getIndexDay(date)] = format(date, "dd/MM/yy");
        date.setDate(date.getDate() + 1);
    }

    return {
        daysData,
        daysLabel
    };
}


function separeted(occurrences, startDate, endDate) {
    const QUANT_DAYS_TO_IGNORE_VIEW_FOR_DAY = 31;
    const SHOW_VIEW_BY_DAY = differenceInDays(endDate, startDate) <= QUANT_DAYS_TO_IGNORE_VIEW_FOR_DAY;

    startDate = new Date(startDate);
    endDate = new Date(endDate);

    let { monthsData, monthsLabel } = generateArrayMonths(startDate, endDate);
    let { weeksData, weeksLabel } = generateArrayWeeks(monthsData, startDate, endDate);

    //Se o periodo de tempo for muito grande a visualização por dia será desativada
    let { daysData, daysLabel } = SHOW_VIEW_BY_DAY ? generateArrayDays(startDate, endDate) : { daysData: [], daysLabel: [] };

    occurrences.forEach((occurrence) => {
        const date = new Date(occurrence.createdAt);

        const indexWeek = getIndexWeek(getWeek(date), date);
        const indexMonth = getIndexMonth(date);

        if (SHOW_VIEW_BY_DAY) {
            const indexDay = getIndexDay(date);
            daysData[indexDay]++;
        }

        monthsData[indexMonth]++;
        weeksData[indexWeek]++;

    });

    return [
        daysData,
        daysLabel,
        weeksData,
        weeksLabel,
        monthsData,
        monthsLabel
    ];

}
export async function updateStates({ dispatch, occurrences, startDate, endDate }) {
    let openOccurrences = [];
    let occurrencesSolved = [];

    occurrences.forEach((occurrence) => {
        //Se a ocorrência for aberta
        if (occurrence.status === "Novo" || occurrence.status === "Em análise") {
            openOccurrences.push(occurrence);
        } else {//Se a ocorrênao não for aberta, é automaticamente atendida
            occurrencesSolved.push(occurrence);
        }
    });

    const [
        daysDataOpen,
        daysLabelOpen,
        weeksDataOpen,
        weeksLabelOpen,
        monthsDataOpen,
        monthsLabelOpen
    ] = separeted(openOccurrences, startDate, endDate);

    const [
        daysDataSolved, ,
        weeksDataSolved, ,
        monthsDataSolved
    ] = separeted(occurrencesSolved, startDate, endDate);

    await dispatch({
        type: 'day',
        dataOpen: daysDataOpen,
        dataSolved: daysDataSolved,
        label: daysLabelOpen,
    });

    await dispatch({
        type: 'week',
        dataOpen: weeksDataOpen,
        dataSolved: weeksDataSolved,
        label: weeksLabelOpen,
    });

    await dispatch({
        type: 'month',
        dataOpen: monthsDataOpen,
        dataSolved: monthsDataSolved,
        label: monthsLabelOpen,
    });
}
